<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('contract') }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'edit-contract?contract_id='+contract_id"
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="contract">{{ $t('contract') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('contract', 1) }} {{ $tc('name', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{contract_name}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('contract') }} {{ $t('description') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{contract_description}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('contract') }} {{ $t('value') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{contract_value}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('isPercentage', 1) }}</div>
              <div
                v-if="contract_is_percentage == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('Yes') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('No') }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('active', 1) }}</div>
              <div
                v-if="contract_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ created_at | dateparse }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{updated_at | dateparse}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DistributorService from "@/services/DistributorService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      contract_id: null,
      contract_name: "",
      contract_description: "",
      contract_value: 0,
      contract_is_percentage: true,
      contract_is_active: true,
      created_by: null,
      created_at: null,
      updated_by: null,
      updated_at: null
    };
  },
  beforeMount() {
    this.contract_id = this.$route.query.contract_id;
    if (this.contract_id) {
      this.getContractDetails();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getContractDetails: function() {
      let payload = {
        contract_id: this.contract_id
      };
      DistributorService.GetSingleContractDetails(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;
          if (data && data.status) {
            let obj = data.Records;
            this.contract_name = obj.contract_name;
            this.contract_description = obj.contract_description;
            this.contract_value = obj.contract_value;
            this.contract_is_percentage = obj.contract_is_percentage;
            this.contract_is_active = obj.contract_is_active;
            this.created_at = obj.created_at;
            this.updated_at = obj.updated_at;
            this.getViewUsersDetails(obj.created_by, "created_by");
            this.getViewUsersDetails(obj.updated_by, "updated_by");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    }
  }
};
</script>

 


// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/ContractComponents/viewContract.vue